module.exports = "virtual-scroll .vs {\n  overflow-y: auto;\n  scroll-behavior: smooth;\n  overflow-x: hidden;\n}\nvirtual-scroll .vs .scrollr {\n  width: 1px;\n  opacity: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/virtual-scroll/virtual-scroll.component.css
// module id = ./src/app/modules/virtual-scroll/virtual-scroll.component.css
// module chunks = main